import { Box } from '@cdl/heartbeat-react';
import { useNavigate } from 'react-router-dom';
import React, { useEffect } from 'react';

const REDIRECT_TIMEOUT = 5000; // ms

export const NotFound: React.FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const timeoutRef = setTimeout(() => navigate('/'), REDIRECT_TIMEOUT);
    return () => clearTimeout(timeoutRef);
  });

  return (
    <Box m='m'>
      The requested url is invalid. <a href='/'>Go to the home page</a>
    </Box>
  );
};
